import React from "react";

const NotFound = (props) => {
    return <div>Not Found</div>;
};

NotFound.propTypes = {};

export default NotFound;
